import { toast } from 'sonner';

/**
 * Surfaces the §3 D5 transient-auth-error to the user. Fired from React
 * Query's queryCache + mutationCache onError so any failed request whose
 * normalised ApiError carries `Authentication service unavailable` (Redis
 * blip) shows a toast — without logging the operator out.
 *
 * The toast id dedupes against a thundering herd: when N parallel queries
 * 401 with this message during the same Redis hiccup, the user sees one
 * toast, not N.
 */
export function maybeShowAuthErrorToast(error: unknown): void {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    (error as { message: unknown }).message === 'Authentication service unavailable'
  ) {
    toast.error('Authentication service temporarily unavailable. Please retry shortly.', {
      id: 'auth-service-unavailable',
    });
  }
}
